import React from "react";

import AppHelper from "../../../util/AppHelper";
import Backstage from "../Backstage/Backstage";
import Context from "../../../context/Context";
import Layout from "./Layout";
import {ModalController} from "../../../common/components/Modal";
import Topic from "../../../context/Topic";
import * as component from "../../../components/util/component";

import { Container } from "../../styles/App/app";

export default class App extends React.Component {
  appHelper;

  constructor(props) {
    super(props);
    this.appHelper = new AppHelper({ app: this });
    this.state = component.newState({
      startupError: null,
      startupErrorDetails: null,
      startupErrorIsFatal: false,
      wasStarted: false
    });
  }

  componentDidMount() {

    try {
      document.getElementById("view-container").style.display = "none";
    } catch(ex) {}

    this.appHelper
      .startupApp()
      .then(result => {
        console.log("started..........");
        this.setState({
          wasStarted: true
        });
      })
      .catch(error => {
        this._handleStartupError(error);
      });

    component.own(this, [
      Topic.subscribe(Topic.ReloadViews, params => {
        this.appHelper
          .reloadViews(params)
          .then(result => {
            console.log("App.reloadViews.complete...");
            if (params.callback) params.callback();
          })
          .catch(ex => {
            console.log("App.reloadViews.error...");
            if (params.callback) params.callback(ex);
            // console.error(ex);
            // component.refresh(this);
          });
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  _handleStartupError(error) {
    const i18n = Context.instance.i18n;
    let msg = null,
      details = null,
      isFatal = false,
      showOpenPlan = true,
      popupError = true;
    const invalidUser = error && (error.xtnCode === "__invalidUser__");
    if (error === "__noIndoorsSubscription__") {
      msg = i18n.messages.noIndoorsSpacesSubscription;
      if (Context.instance.noIndoorsSubscriptionMsg) {
        msg = Context.instance.noIndoorsSubscriptionMsg;
      }
      isFatal = true;
    } else if (error === "__notAnIndoorsApp__") {
      msg = i18n.messages.notAnIndoorsApp;
      //isFatal = true;
    } else if (error && error.message === "No webmap was specified") {
      msg = i18n.messages.noWebmapSpecified;
      popupError = false;
    } else {
      console.error("Startup error", error);
      msg = (error && error.message) || null;
      if (error && error.xtnIsFatal) isFatal = true;
    }
    this.setState({
      startupError: msg,
      startupErrorDetails: details,
      startupErrorIsFatal: isFatal,
      showOpenPlan: showOpenPlan
    });

    const cfgOn = Context.instance.uiMode.isConfiguratorOn;
    if (!isFatal) {
      if (popupError) {
        let title = i18n.spaceplanner.application.errorStartingAppTitle;
        if (invalidUser) title = i18n.spaceplanner.application.insufficientRoleTitle;
        ModalController.confirm({
          isError: true,
          title: title,
          hideCancel: true,
          content: (
            <div>
              <div>{msg}</div>
              <div>{details}</div>
            </div>
          )
        }).then(() => {
          if (invalidUser) {
            Topic.publish(Topic.SignOutClicked,{});
          } else {
            if (!cfgOn) {
              Topic.publish(Topic.ShowBackstage, { tabKey: "openPlan" });
            }
          }
        });
      } else if (showOpenPlan) {
        if (!cfgOn) {
          if (Context.instance.user.canConfigureApp()) {
            Context.instance.uiMode.toggleConfigurator(true);
            Topic.publish(Topic.ConfiguratorActivated,{});
          } else {
            Topic.publish(Topic.ShowBackstage, { tabKey: "openPlan" });
          }
        }
      }
    }
  }

  render() {
    if (this.state.startupErrorIsFatal) {
      const errorMsg = this.state.startupError;
      const errorDetails = this.state.startupErrorDetails || "";
      const errorNode = (
        <div key="err" className="i-startup-error i-padded">
          <div>{errorMsg}</div>
          <div>{errorDetails}</div>
        </div>
      );
      return errorNode;
    }

    return (
      <Container>
        <Layout />
        <Backstage />
      </Container>
    );
  }
}
